module.exports = __webpack_public_path__ + "img/txt.3f4455ae.svg";